<template>
  <v-container>
    <v-alert v-if="error" type="error">{{error}}</v-alert>
    <v-form ref="loginForm" v-model="valid">
      <v-row>
        <v-col cols="12">
          <v-text-field 
            v-model="loginForm.email" 
            label="Email"
            :rules="emailRules"
            required
          >
          </v-text-field>
        </v-col>

        <v-col cols="12">
          <v-text-field
            v-model="loginForm.password" 
            label="Password"
            type="password"
            required
          >
          </v-text-field>
        </v-col>
      </v-row>
      <v-btn @click="submit">Login</v-btn>
    </v-form>
  </v-container>
</template>


<script>
import firebase from "firebase";

export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        email: "",
        password: ""
      },
      error: null,
      valid: false,
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ]
    };
  },
  methods: {
    submit() {
      this.$refs.loginForm.validate();
      firebase
        .auth()
        .signInWithEmailAndPassword(this.loginForm.email, this.loginForm.password)
        .then(() => {
          this.$router.replace({ name: "Dashboard" });
        })
        .catch(err => {
          this.error = err.message;
        });
    }
  }
};
</script>